"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ByteLength = exports.hexStringToBytes = exports.toUTF8String = exports.fromUTF8String = exports.hexlify = exports.numberify = exports.hexToBigInt = exports.nToHex = exports.bytesToHex = exports.getRandomBytes = exports.parseRailgunTokenAddress = void 0;
const engine_1 = require("@railgun-community/engine");
Object.defineProperty(exports, "ByteLength", { enumerable: true, get: function () { return engine_1.ByteLength; } });
Object.defineProperty(exports, "hexlify", { enumerable: true, get: function () { return engine_1.hexlify; } });
Object.defineProperty(exports, "fromUTF8String", { enumerable: true, get: function () { return engine_1.fromUTF8String; } });
Object.defineProperty(exports, "toUTF8String", { enumerable: true, get: function () { return engine_1.toUTF8String; } });
Object.defineProperty(exports, "hexStringToBytes", { enumerable: true, get: function () { return engine_1.hexStringToBytes; } });
Object.defineProperty(exports, "nToHex", { enumerable: true, get: function () { return engine_1.nToHex; } });
Object.defineProperty(exports, "hexToBigInt", { enumerable: true, get: function () { return engine_1.hexToBigInt; } });
Object.defineProperty(exports, "numberify", { enumerable: true, get: function () { return engine_1.numberify; } });
const parseRailgunTokenAddress = (tokenAddress) => {
    return (0, engine_1.formatToByteLength)(tokenAddress, engine_1.ByteLength.Address, true);
};
exports.parseRailgunTokenAddress = parseRailgunTokenAddress;
const getRandomBytes = (length) => {
    return (0, engine_1.randomHex)(length);
};
exports.getRandomBytes = getRandomBytes;
const bytesToHex = (bytes) => {
    return Buffer.from(bytes).toString('hex');
};
exports.bytesToHex = bytesToHex;
